import { LockOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

type FillableFormVisibilityLabelProps = {
  val: 0 | 1 | 2 | 3;
  tooltipLabel: string;
};

export const FillableFormVisibilityLabel = ({
  val,
  tooltipLabel,
}: FillableFormVisibilityLabelProps) => {
  if (val === 0) {
    return (
      <Tooltip
        placement="top"
        overlayClassName="text-sm"
        title={`The ${tooltipLabel} is not visible in the portal`}
      >
        <LockOutlined className="text" />
      </Tooltip>
    );
  }

  if (val === 1) {
    return <span className="text-md">Seller</span>;
  }

  if (val === 2) {
    return <span className="text-md">Buyer</span>;
  }

  if (val === 3) {
    return <span className="text-md">Seller & Buyer</span>;
  }

  return <></>;
};
